import EventCardBanner, {
  EventCardBannerView,
  GET_BANNER_DATA,
  EVENT_CARD_BANNER_PHOTO,
  EVENT_CARD_BANNER_PHOTO_ALT,
  EVENT_CARD_BANNER_LOGO,
  EVENT_CARD_BANNER_LOGO_ALT,
} from './event-card-banner'

export {
  EventCardBannerView,
  GET_BANNER_DATA,
  EVENT_CARD_BANNER_PHOTO,
  EVENT_CARD_BANNER_PHOTO_ALT,
  EVENT_CARD_BANNER_LOGO,
  EVENT_CARD_BANNER_LOGO_ALT,
}
export default EventCardBanner
